import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {EmptyFolderIcon} from 'shells/icon/svg/empty-folder-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {FooterBar} from 'shells/modal/footer-bar';
import {Modal} from 'shells/modal/modal';
import {Radio} from 'shells/radio/radio';
import {RadioGroup} from 'shells/radio/radio-group';

export type AfterArchive = 'uncategorizeTemplates' | 'archiveTemplates';

type Props = {
    isSaving: boolean;
    onClose: () => void;
    onArchive: (arg1: AfterArchive) => void;
};

export function ArchiveGroupModal(props: Props) {
    const [afterArchive, setAfterArchive] = React.useState<AfterArchive>('uncategorizeTemplates');
    const buttonText =
        afterArchive === 'uncategorizeTemplates'
            ? 'Archive template group'
            : 'Archive group & templates';

    return (
        <Modal
            isOpen={true}
            headerText='Archive template group'
            onClose={props.onClose}
            maxWidth={400}
            maxHeight={300}
            closeButton={false}
        >
            <StackLegacy spacing={16}>
                <div>
                    When this template group is archived, what should happen to the templates
                    inside?
                </div>
                <RadioGroup
                    name='sort-direction'
                    selectedValue={afterArchive}
                    // @ts-expect-error
                    onChange={(value: AfterArchive) => setAfterArchive(value)}
                >
                    <Radio value='uncategorizeTemplates'>
                        <StackLegacy spacing={8} isHorizontal={true}>
                            <EmptyFolderIcon size={16} />
                            <div>
                                Keep & add templates to <i>Unorganized</i>
                            </div>
                        </StackLegacy>
                    </Radio>
                    <Radio value='archiveTemplates'>
                        <StackLegacy spacing={8} isHorizontal={true}>
                            <TrashIcon size={16} color={colors.rose} />
                            <div>Also archive templates</div>
                        </StackLegacy>
                    </Radio>
                </RadioGroup>
            </StackLegacy>
            <FooterBar
                left={
                    <Button variant='text' onClick={props.onClose} noPadding={true}>
                        Cancel
                    </Button>
                }
                right={
                    <SaveButton
                        variant='danger'
                        isSaving={props.isSaving}
                        // @ts-expect-error
                        onClick={() => props.onArchive(afterArchive)}
                        buttonText={buttonText}
                        savingText='Archiving'
                    />
                }
                absolutePosition={true}
            />
        </Modal>
    );
}
